'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapContainer = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _googleMapsReact = require('google-maps-react');

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapContainer = exports.MapContainer = function (_Component) {
  (0, _inherits3.default)(MapContainer, _Component);

  function MapContainer() {
    (0, _classCallCheck3.default)(this, MapContainer);
    return (0, _possibleConstructorReturn3.default)(this, (MapContainer.__proto__ || (0, _getPrototypeOf2.default)(MapContainer)).apply(this, arguments));
  }

  return MapContainer;
}(_react.Component);

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
  apiKey: 'AIzaSyCwqtyMa_0ahAyOfdp4tAPi_pBcdQQafd0'
})(MapContainer);


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleMap/GoogleMap.js
// module id = 1521
// module chunks = 0